<template>
  <div v-show="dialog">
    <div class="modal">
      <form @submit.prevent="submit">
        <button @click="dismiss" type="button">✕</button>
        <h1>Nevíte si rady s výběrem?</h1>
        <p>Vyplňte telefonní číslo a my Vám poradíme.</p>
        <input
            type="tel"
            name="phone"
            placeholder="Telefon"
            v-model="contactPhone"
            required
        >
        <div class="buttons big">
          <button
              :disabled="isContactDisabled"
              class="button btn-small btn-orange"
              type="submit"
          >Odeslat</button>
        </div>
        <small>Odesláním souhlasíte se <a target="_blank" href="/pdf/gdpr.pdf">zpracováním osobních údajů</a> a <a target="_blank" href="/pdf/vop.pdf">podmínkami</a>.</small>
      </form>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import QS from 'qs'

export default {
  name: 'VDialogContact',
  data() {
    return {
      dialog: false,
      contactPhone: null,
      recaptchaToken: null,
      sending: false
    }
  },
  computed: {
    isContactDisabled() {
      return !this.contactPhone || this.sending
    }
  },
  mounted() {
    const result = window.localStorage.getItem('spolehlivy.cz-dialog')
    if (result === null) {
      const self = this
      window.setTimeout(function () {
        console.log('timeout')
        self.dialog = true
      }, 15000)
    }
  },
  methods: {
    dismiss() {
      window.localStorage.setItem('dobryinternet.cz-dialog', Math.floor(Date.now() / 1000).toString())
      this.dialog = false
    },
    submit() {
      // A second click while reCAPTCHA or the request runs would send a duplicate inquiry.
      if (this.sending) return
      this.sending = true
      grecaptcha.ready(() => {
        grecaptcha.execute('6LdqfG4qAAAAAK-_T0rAXmj3g5ti3T-SsWGi-o_i', {action: 'submit'}).then((token) => {
          this.recaptchaToken = token;

          // Send form data along with the reCAPTCHA token
          Axios.post('/poptavka', QS.stringify({
            contactPhone: this.contactPhone,
            recaptchaToken: this.recaptchaToken
          }))
              .then((result) => {
                this.contactPhone = null
                this.dismiss()
                window.location.href = '/dekujeme-za-poptavku'
              })
              .catch(() => {
                alert('Nastala chyba při odeslání kontaktního formuláře')
                this.sending = false
              });
        });
      });
    }
  }
}
</script>
